var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { State, Getter, Action } from 'vuex-class';
import { PageService } from '~/utils/page.service';
import { PrincipalService } from '~/services/domain-service/principal.service';
import ModifyClient from '~/components/case-import/client-manage/modify-client.vue';
var ClientManage = /** @class */ (function (_super) {
    __extends(ClientManage, _super);
    function ClientManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clientModel = {
            principalName: '',
            principalPhone: '',
            principalCode: '',
            outSourceType: '',
            commonState: '',
            collectArea: '',
            areaId: '',
            areaIds: [],
            contactName: ''
        };
        _this.clientDataSet = [];
        _this.dialog = {
            modify: false,
        };
        _this.clientObj = {};
        return _this;
    }
    /**
     * 查询委托方
     */
    ClientManage.prototype.refreshData = function () {
        var _this = this;
        this.clientModel.areaId = this.clientModel.areaIds && this.clientModel.areaIds.length > 0 ? this.clientModel.areaIds[this.clientModel.areaIds.length - 1] : '';
        this.principalService
            .getPrincipalList(this.clientModel, this.pageService)
            .subscribe(function (data) {
            _this.clientDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    ClientManage.prototype.mounted = function () {
        this.refreshData();
        this.getCompanyList();
    };
    __decorate([
        State
    ], ClientManage.prototype, "principalList", void 0);
    __decorate([
        Getter
    ], ClientManage.prototype, "isSupperAdmin", void 0);
    __decorate([
        Action
    ], ClientManage.prototype, "getPrincipalList", void 0);
    __decorate([
        Action
    ], ClientManage.prototype, "getCompanyList", void 0);
    __decorate([
        Dependencies(PageService)
    ], ClientManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], ClientManage.prototype, "principalService", void 0);
    ClientManage = __decorate([
        Auth(104),
        Layout('workspace'),
        Component({
            components: {
                ModifyClient: ModifyClient,
            },
        })
    ], ClientManage);
    return ClientManage;
}(Vue));
export default ClientManage;
